import { NETWORKS, type Network, type NetworkCaip } from '../types'
import { getNetworkFromCaip } from './getNetworkFromCaip'

export function getNetworkNameFromNetworkOrCaip(networkNameOrCaip: Network | NetworkCaip): Network {
  return NETWORKS.includes(networkNameOrCaip as Network)
    ? (networkNameOrCaip as Network)
    : getNetworkFromCaip(networkNameOrCaip as NetworkCaip)
}
